import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fromJS, List } from "immutable";
import { formatCurrency } from "../util/number.js";
import { ruleBls } from "./constants.js";
import { createSelector } from "reselect";
var MILEAGE_PACKAGE = ruleBls.MILEAGE_PACKAGE,
  CDW = ruleBls.CDW,
  S_CDW = ruleBls.S_CDW,
  DELIVERY = ruleBls.DELIVERY;
var RENT_CONTRACT = "rentContract";
var savedState = JSON.parse(sessionStorage.getItem(RENT_CONTRACT) || "{}");
export function rentContractsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : savedState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case "RENT_CONTRACTS/RENT_CONTRACT_LOADED":
      {
        var _action$payload$rentC;
        sessionStorage.setItem(RENT_CONTRACT, JSON.stringify({
          rentContract: {
            id: (_action$payload$rentC = action.payload.rentContract) === null || _action$payload$rentC === void 0 ? void 0 : _action$payload$rentC.id
          }
        }));
        return _objectSpread(_objectSpread({}, state), {}, {
          rentContract: action.payload.rentContract
        });
      }
    case "RENT_CONTRACTS/SUBMIT_RENT_CONTRACT_LOADED":
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          rentContract: action.payload
        });
      }
    case "RENT_CONTRACTS/RENT_CONTRACT_CLEAR":
      sessionStorage.clear();
      return _objectSpread(_objectSpread({}, state), {}, {
        rentContract: _objectSpread({}, action.payload),
        deliveryAddress: null
      });
    case "RENT_CONTRACTS/DELIVERY_ADDRESS_LOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        deliveryAddress: action.payload
      });

    // when user is logged out, clean up data of the leaving user from the store and session
    case "USER/USER_LOGGED_OUT":
      sessionStorage.clear();
      return _objectSpread(_objectSpread({}, state), {}, {
        rentContract: null,
        deliveryAddress: null
      });
    default:
      return state;
  }
}
var getRawRentContract = function getRawRentContract(state) {
  var _state$rent_contracts;
  return state === null || state === void 0 || (_state$rent_contracts = state.rent_contracts) === null || _state$rent_contracts === void 0 ? void 0 : _state$rent_contracts.rentContract;
};
export var getRentContract = createSelector([getRawRentContract], function (rentContract) {
  return rentContract ? fromJS(rentContract) : undefined;
});
export var getRentContractId = createSelector([getRentContract], function (rentContract) {
  return rentContract ? rentContract.get("id") : undefined;
});
export var getReservationNo = createSelector([getRentContract], function (rentContract) {
  return rentContract && rentContract.get("reservationNo") ? String(rentContract.get("reservationNo")) : undefined;
});
export var getMainRentObjectTransaction = createSelector([getRentContract], function (rentContract) {
  return rentContract ? (rentContract.get("rentObjTransacts") || List()).find(function (transaction) {
    return transaction.get("transactType") === "RC";
  }) : undefined;
});
var getRawInvoiceItems = createSelector([getRentContract], function (rentContract) {
  return rentContract ? rentContract.get("invoiceItems", List()) : List();
});
var invoiceItemDescription = function invoiceItemDescription(invoiceItem) {
  return invoiceItem.get("wwwDescr") || invoiceItem.get("shortDescr");
};
export var getInvoiceItems = createSelector([getRawInvoiceItems], function (invoiceItems) {
  return invoiceItems.sortBy(function (invoiceItem) {
    return invoiceItem.get('sortNo');
  }).map(function (invoiceItem) {
    return invoiceItem.update("included", function (included) {
      return included === "YE";
    }).set("description", invoiceItemDescription(invoiceItem));
  });
});
export var getEnabledInvoiceItems = createSelector([getInvoiceItems], function (invoiceItems) {
  return invoiceItems.filter(function (invoiceItem) {
    return invoiceItem.get("enabled");
  });
});
export var getMileageInvoiceItems = createSelector([getInvoiceItems], function (invoiceItems) {
  return invoiceItems.filter(function (invoiceItem) {
    return invoiceItem.get("ruleBL") === MILEAGE_PACKAGE;
  });
});
export var getDeductibleInvoiceItems = createSelector([getInvoiceItems], function (invoiceItems) {
  return invoiceItems.filter(function (invoiceItem) {
    return [CDW, S_CDW].includes(invoiceItem.get("ruleBL"));
  });
});
export var getDeliveryInvoiceItem = createSelector([getInvoiceItems], function (invoiceItems) {
  return invoiceItems.find(function (invoiceItem) {
    return invoiceItem.get("ruleBL") === DELIVERY;
  });
});
export var getIsPromocodeActivated = createSelector([getRentContract], function (rentContract) {
  return rentContract ? rentContract.get("priceWithoutPromocode") !== 0 : false;
});
export var getPromocodeSavedAmount = createSelector([getRentContract, getIsPromocodeActivated], function (rentContract, isPromocodeActivated) {
  return isPromocodeActivated && rentContract ? rentContract.get("priceWithoutPromocode", 0) - rentContract.get("amountSumGross", 0) : 0;
});
export var getFormattedPromocodeSavedAmount = createSelector([getPromocodeSavedAmount], function (promocodeSavedAmount) {
  return formatCurrency(-1 * promocodeSavedAmount);
});
var getRawDeliveryAddres = function getRawDeliveryAddres(state) {
  var _state$rent_contracts2;
  return state === null || state === void 0 || (_state$rent_contracts2 = state.rent_contracts) === null || _state$rent_contracts2 === void 0 ? void 0 : _state$rent_contracts2.deliveryAddress;
};
export var getDeliveryAddres = createSelector([getRawDeliveryAddres], function (deliveryAddress) {
  return deliveryAddress ? fromJS(deliveryAddress) : undefined;
});
export var getRawDeliveryAddress = createSelector([getRentContractId, getDeliveryAddres], function (rentContractId, deliveryAddress) {
  return deliveryAddress && deliveryAddress.get("rentContractId") === rentContractId ? deliveryAddress.get("deliveryAddress") : undefined;
});